import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { EmployeeComponent } from './pages/dashboard/employee/employee.component';
import { TeamComponent } from './pages/dashboard/team/team.component';
import { ExpenseCategoryComponent } from './pages/dashboard/expense-category/expense-category.component';
import { TagComponent } from './pages/dashboard/tag/tag.component';
import { HomeComponent } from './pages/dashboard/home/home.component';
import { ActionTeamComponent } from './pages/dashboard/team/action-team/action-team.component';
import { ActionEmployeeComponent } from './pages/dashboard/employee/action-employee/action-employee.component';
import { ActionTagComponent } from './pages/dashboard/tag/action-tag/action-tag.component';
import { PositionComponent } from './pages/dashboard/position/position.component';
import { ActionPositionComponent } from './pages/dashboard/position/action-position/action-position.component';
import { ActionExpenseCategoryComponent } from './pages/dashboard/expense-category/action-expense-category/action-expense-category.component';
import { ReimbursementClaimerComponent } from './pages/dashboard/reimbursement-claimer/reimbursement-claimer.component';
import { ActionReimbursementClaimerComponent } from './pages/dashboard/reimbursement-claimer/action-reimbursement-claimer/action-reimbursement-claimer.component';
import { ReimbursementApprovalComponent } from './pages/dashboard/reimbursement-approval/reimbursement-approval.component';
import { ActionReimbursementApprovalComponent } from './pages/dashboard/reimbursement-approval/action-reimbursement-approval/action-reimbursement-approval.component';
import { ReportComponent } from './pages/dashboard/report/report.component';
import { AuthGuard } from './core/guards/auth.guard';
import { LoginGuard } from './core/guards/login.guard';
import { ResubmitReimbursementComponent } from './pages/dashboard/reimbursement-claimer/resubmit-reimbursement/resubmit-reimbursement.component';
import { ReimbursementFinanceComponent } from './pages/dashboard/reimbursement-finance/reimbursement-finance.component';
import { ActionReimbursementFinanceComponent } from './pages/dashboard/reimbursement-finance/action-reimbursement-finance/action-reimbursement-finance.component';
import { CashAdvanceClaimerComponent } from './pages/dashboard/cash-advance-claimer/cash-advance-claimer.component';
import { ActionCashAdvanceClaimerComponent } from './pages/dashboard/cash-advance-claimer/action-cash-advance-claimer/action-cash-advance-claimer.component';
import { CashAdvanceApprovalComponent } from './pages/dashboard/cash-advance-approval/cash-advance-approval.component';
import { ActionCashAdvanceApprovalComponent } from './pages/dashboard/cash-advance-approval/action-cash-advance-approval/action-cash-advance-approval.component';
import { CashAdvanceFinanceComponent } from './pages/dashboard/cash-advance-finance/cash-advance-finance.component';
import { ActionCashAdvanceFinanceComponent } from './pages/dashboard/cash-advance-finance/action-cash-advance-finance/action-cash-advance-finance.component';
import { CashAdvanceSettlementComponent } from './pages/dashboard/cash-advance-settlement/cash-advance-settlement.component';
import { ActionCashAdvanceSettlementComponent } from './pages/dashboard/cash-advance-settlement/action-cash-advance-settlement/action-cash-advance-settlement.component';
import { ProfileComponent } from './pages/dashboard/profile/profile.component';
import { FaqComponent } from './pages/dashboard/faq/faq.component';
import { ViewProfileComponent } from './pages/dashboard/profile/view-profile/view-profile.component';
import { FinanceOverviewComponent } from './pages/dashboard/finance-overview/finance-overview.component';
import { FinalTransactionRecapComponent } from './pages/dashboard/final-transaction-recap/final-transaction-recap.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard],
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        component: HomeComponent,
      },
      {
        path: 'employee',
        children: [
          {
            path: '',
            component: EmployeeComponent,
          },
          {
            path: 'action',
            component: ActionEmployeeComponent,
          },
        ],
      },
      {
        path: 'team',
        children: [
          {
            path: '',
            component: TeamComponent,
          },
          {
            path: 'action',
            component: ActionTeamComponent,
          },
        ],
      },
      {
        path: 'expense-category',
        children: [
          {
            path: '',
            component: ExpenseCategoryComponent,
          },
          {
            path: 'action',
            component: ActionExpenseCategoryComponent,
          },
        ],
      },
      {
        path: 'tag',
        children: [
          {
            path: '',
            component: TagComponent,
          },
          {
            path: 'action',
            component: ActionTagComponent,
          },
        ],
      },
      {
        path: 'position',
        children: [
          {
            path: '',
            component: PositionComponent,
          },
          {
            path: 'action',
            component: ActionPositionComponent,
          },
        ],
      },
      {
        path: 'reimbursement-claimer',
        children: [
          {
            path: '',
            component: ReimbursementClaimerComponent,
          },
          {
            path: 'resubmit',
            component: ResubmitReimbursementComponent,
          },
          {
            path: 'action',
            component: ActionReimbursementClaimerComponent,
          },
        ],
      },
      {
        path: 'reimbursement-approval',
        children: [
          {
            path: '',
            component: ReimbursementApprovalComponent,
          },
          {
            path: 'action',
            component: ActionReimbursementApprovalComponent,
          },
        ],
      },
      {
        path: 'reimbursement-finance',
        children: [
          {
            path: '',
            component: ReimbursementFinanceComponent,
          },
          {
            path: 'action',
            component: ActionReimbursementFinanceComponent,
          },
        ],
      },
      {
        path: 'cash-advance-claimer',
        children: [
          {
            path: '',
            component: CashAdvanceClaimerComponent,
          },
          {
            path: 'action',
            component: ActionCashAdvanceClaimerComponent,
          },
        ],
      },
      {
        path: 'cash-advance-approval',
        children: [
          {
            path: '',
            component: CashAdvanceApprovalComponent,
          },
          {
            path: 'action',
            component: ActionCashAdvanceApprovalComponent,
          },
        ],
      },
      {
        path: 'cash-advance-finance',
        children: [
          {
            path: '',
            component: CashAdvanceFinanceComponent,
          },
          {
            path: 'action',
            component: ActionCashAdvanceFinanceComponent,
          },
        ],
      },
      {
        path: 'cash-advance-settlement',
        children: [
          {
            path: '',
            component: CashAdvanceSettlementComponent,
          },
          {
            path: 'action',
            component: ActionCashAdvanceApprovalComponent,
          },
        ],
      },
      {
        path: 'finance-overview',
        component: FinanceOverviewComponent,
      },
      {
        path: 'report',
        component: ReportComponent,
      },
      {
        path: 'final-transaction-recap',
        component: FinalTransactionRecapComponent,
      },
      {
        path: 'profile',
        children: [
          {
            path: '',
            component: ProfileComponent,
          },
          {
            path: 'view',
            component: ViewProfileComponent,
          },
        ],
      },
      {
        path: 'faq',
        component: FaqComponent,
      },
    ],
  },
];
